import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatUnderScoreLowerCase, getAmplitudeKeyValue } from '@utils/utils';

type SelectedAccount = {
  icon: string;
  color: string;
  displayName: string;
  balance?: number;
  accountTypeId?: number;
  accountId?: number;
  amplitudeAccountName?: string;
};
type MeAmplitudeContext = {
  key: string;
  value: string | number;
  event: string[];
};

type Source = string; // Assuming source is a string, based on previous context

export function logAccountSelected(
  source: Source,
  accountDetails: SelectedAccount,
  meAmplitudeContext: MeAmplitudeContext[],
) {
  const e = AMPLITUDE_CONSTANTS.account_drop_down_selected;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
    [e.attributes.dynamic_account_name]: formatUnderScoreLowerCase(accountDetails?.amplitudeAccountName),
    ...getAmplitudeKeyValue(e.name, meAmplitudeContext),
  });
}

export function logAccountClick(
  source: Source,
  selectedAccount: SelectedAccount,
  meAmplitudeContext: MeAmplitudeContext[],
) {
  const e = AMPLITUDE_CONSTANTS.account_drop_down_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
    [e.attributes.dynamic_account_name]: formatUnderScoreLowerCase(selectedAccount?.amplitudeAccountName),
    ...getAmplitudeKeyValue(e.name, meAmplitudeContext),
  });
}
